module.exports = __webpack_public_path__ + "static/media/tiny-man.cc24a75e.glb";